import React from 'react';
import classNames from 'classnames';
import { CardData } from '@nvs/gatsby-theme-leap-core/src/components/domains/confirmation/components/services/card';
import useTranslation from '@nvs/gatsby-theme-leap-core/src/hooks/useTranslation';
import BrandLogo from '@nvs/gatsby-theme-leap-core/src/components/hoc/components/logo/logo';

const CardRight: React.FC<{ data: CardData; printMode?: boolean }> = ({
	data,
	printMode = false,
}) => {
	const { t } = useTranslation();

	return (
		<div
			className={classNames(
				'basis-[70%] rounded-br-2xl rounded-tr-2xl flex flex-col justify-end items-center p-2 gap-5 sm:gap-7',
				{
					'': !printMode,
				}
			)}>
			<div className='flex flex-col gap-5 sm:gap-9 items-center'>
				<div>
					<BrandLogo />
				</div>
				<div className="flex flex-col text-left text-sm whitespace-normal leading-none sm:leading-tight">
					<div className="flex gap-x-1 sm:gap-2">
						<div className="w-9">{t('pages.confirmation.card.bin')}</div>
						<div className="font-bold">{data.bin}</div>
					</div>
					<div className="flex gap-x-1 sm:gap-2">
						<div className="w-9">{t('pages.confirmation.card.pcn')}</div>
						<div className="font-bold">{data.pcn}</div>
					</div>
					<div className="flex gap-x-1 sm:gap-2">
						<div className="w-9">{t('pages.confirmation.card.grp')}</div>
						<div className="font-bold">{data.group}</div>
					</div>
					<div className="flex gap-x-1 sm:gap-2">
						<div className="w-9">{t('pages.confirmation.ftocard.id')}</div>
						<div className="font-bold">{data.memberId}</div>
					</div>
				</div>
			</div>
			<div className={classNames(
				'bg-repeat-round w-full h-4 sm:h-6 sm:bg-[length:5%]',
				{
					'bg-novartis-singlechain': !printMode,
					'bg-novartis-singlechain-print opacity-30': printMode,
				}
			)}>
			</div>
		</div>
	);
};

export default CardRight;
